/**
 * Types should be a superset of the ReferenceTypes
 * described in the previous iteration of this library,
 * taken from reference-resolvers/constants/ReferenceTypes.js
 *
 * This is the set of enums that a client should use to
 * reference one of the valid reference resolvers within
 * this library.
 */

/**
 * Add new external option types to this object whenever BE support
 * is added.
 *
 * See https://git.hubteam.com/HubSpot/ExternalOptions/blob/master/ExternalOptionsCore/src/main/java/com/hubspot/externaloptions/core/ReferenceType.java#L10
 */
const ExternalOptionsReferenceTypes = {
  OWNER: 'OWNER',
  TEAM: 'TEAM',
  MULTI_CURRENCY_CURRENCY_CODE: 'MULTI_CURRENCY_CURRENCY_CODE',
  PERSONA: 'PERSONA',
  PIPELINE: 'PIPELINE',
  PIPELINE_STAGE: 'PIPELINE_STAGE',
  SEQUENCE: 'SEQUENCE',
  WORKFLOW: 'WORKFLOW',
  BUSINESS_UNIT: 'BUSINESS_UNIT',
  ORIGINAL_SOURCE_1: 'ORIGINAL_SOURCE_1',
  CAMPAIGN: 'CAMPAIGN',
  TASK_QUEUE: 'TASK_QUEUE',
  CRM_OBJECT: 'CRM_OBJECT',
  USER: 'USER',
  CHANNEL_INSTANCE: 'CHANNEL_INSTANCE',
  GENERIC_CHANNEL: 'GENERIC_CHANNEL',
  TRACKED_TERM: 'TRACKED_TERM',
  SEQUENCE_WITH_PERMISSIONS: 'SEQUENCE_WITH_PERMISSIONS',
  PIPELINE_WITH_PERMISSIONS: 'PIPELINE_WITH_PERMISSIONS',
  PIPELINE_STAGE_WITH_PERMISSIONS: 'PIPELINE_STAGE_WITH_PERMISSIONS',
  CRM_OBJECT_TAG: 'CRM_OBJECT_TAG',
  STATIC_CONTACT_LIST: 'STATIC_CONTACT_LIST',
  STATIC_INBOUND_DB_LIST: 'STATIC_INBOUND_DB_LIST',
  OPTIMIZATION_TYPE: 'OPTIMIZATION_TYPE',
  CALL_DISPOSITION: 'CALL_DISPOSITION',
  AD_ACCOUNT: 'AD_ACCOUNT',
  SALES_DOCUMENT: 'SALES_DOCUMENT',
  MARKETING_SMS_ROOT_MIC: 'MARKETING_SMS_ROOT_MIC',
  MEETING_OUTCOME: 'MEETING_OUTCOME',
  SYNC_ACCOUNT: 'SYNC_ACCOUNT',
  PERMISSION_SET: 'PERMISSION_SET',
  SEAT: 'SEAT',
  SOURCE_LABEL: 'SOURCE_LABEL'
};
/**
 * While the default api uses the ExternalOptions service,
 * resolvers can make calls to any api. Therefore, this
 * set of enums won't always reflect support via the
 * ExternalOptions service.
 */

export const MULTI_CURRENCY_CURRENCY_CODE = ExternalOptionsReferenceTypes.MULTI_CURRENCY_CURRENCY_CODE;
export const OWNER = ExternalOptionsReferenceTypes.OWNER;
export const PERSONA = ExternalOptionsReferenceTypes.PERSONA;
export const TEAM = ExternalOptionsReferenceTypes.TEAM;
export const PIPELINE = ExternalOptionsReferenceTypes.PIPELINE;
export const PIPELINE_STAGE = ExternalOptionsReferenceTypes.PIPELINE_STAGE;
export const WORKFLOW = ExternalOptionsReferenceTypes.WORKFLOW;
export const BUSINESS_UNIT = ExternalOptionsReferenceTypes.BUSINESS_UNIT;
export const CRM_OBJECT = ExternalOptionsReferenceTypes.CRM_OBJECT;
export const USER = ExternalOptionsReferenceTypes.USER;
export const TRACKED_TERM = ExternalOptionsReferenceTypes.TRACKED_TERM;
export const SEQUENCE = ExternalOptionsReferenceTypes.SEQUENCE;
export const SEQUENCE_WITH_PERMISSIONS = ExternalOptionsReferenceTypes.SEQUENCE_WITH_PERMISSIONS;
export const CAMPAIGN = ExternalOptionsReferenceTypes.CAMPAIGN;
export const TASK_QUEUE = ExternalOptionsReferenceTypes.TASK_QUEUE;
export const PIPELINE_WITH_PERMISSIONS = ExternalOptionsReferenceTypes.PIPELINE_WITH_PERMISSIONS;
export const PIPELINE_STAGE_WITH_PERMISSIONS = ExternalOptionsReferenceTypes.PIPELINE_STAGE_WITH_PERMISSIONS;
export const CRM_OBJECT_TAG = ExternalOptionsReferenceTypes.CRM_OBJECT_TAG;
export const STATIC_CONTACT_LIST = ExternalOptionsReferenceTypes.STATIC_CONTACT_LIST;
export const STATIC_INBOUND_DB_LIST = ExternalOptionsReferenceTypes.STATIC_INBOUND_DB_LIST;
export const OPTIMIZATION_TYPE = ExternalOptionsReferenceTypes.OPTIMIZATION_TYPE;
export const MARKETING_SMS_ROOT_MIC = ExternalOptionsReferenceTypes.MARKETING_SMS_ROOT_MIC;
export const MEETING_OUTCOME = ExternalOptionsReferenceTypes.MEETING_OUTCOME;
export const SYNC_ACCOUNT = ExternalOptionsReferenceTypes.SYNC_ACCOUNT;
export const CALL_DISPOSITION = ExternalOptionsReferenceTypes.CALL_DISPOSITION;
export const AD_ACCOUNT = ExternalOptionsReferenceTypes.AD_ACCOUNT;
export const SALES_DOCUMENT = ExternalOptionsReferenceTypes.SALES_DOCUMENT;
export const ORIGINAL_SOURCE_1 = ExternalOptionsReferenceTypes.ORIGINAL_SOURCE_1;
export const CHANNEL_INSTANCE = ExternalOptionsReferenceTypes.CHANNEL_INSTANCE;
export const GENERIC_CHANNEL = ExternalOptionsReferenceTypes.GENERIC_CHANNEL;
export const PERMISSION_SET = ExternalOptionsReferenceTypes.PERMISSION_SET;
export const SEAT = ExternalOptionsReferenceTypes.SEAT;
export const SOURCE_LABEL = ExternalOptionsReferenceTypes.SOURCE_LABEL;